import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * Sample Column Config: {
 *   id: Id of the column
 *   header: Title of the column
 *   cellConfigs: {
 *     component: Component to render in the cell,
 *     shouldRender: Function returning a boolean whether to render the component or not.
 *     mapCellPropsToComponentProps: Mapper function to map cell props to custom component props if needed.
 *   }
 *   headerClassName: Class name to be given to the header
 *   cellClassName: Classname for the cell.
 *   width: PropTypes.number
 *   accessor: Function to access the value
 *   getValueFromOnChange: Function which maps the return value for the chanbe
 * }
 */
import _noop from 'lodash/noop';
import _identity from 'lodash/identity';

// Utils
import getArraySafeValue from '@tekion/tekion-base/utils/getArraySafeValue';
var ColumnConfig = /*#__PURE__*/function () {
  function ColumnConfig(columnId) {
    _classCallCheck(this, ColumnConfig);
    this.id = columnId;
    this.key = columnId;
    this.cellConfigs = [];
    this.accessor = _noop;
    this.searchAccessor = undefined;
    this.searchTextNormalizer = undefined;
    this.getValueFromOnChange = _noop;
    this.footer = _noop;
    this.getValueOnPeriodPress = _identity;
    this.getValueForKeyboardShortcuts = getArraySafeValue;
    this.getFooterProps = _noop;
    this.getHeaderProps = _noop;
    this.header = undefined;
    this.headerProps = undefined;
    this.children = [];
  }
  _createClass(ColumnConfig, [{
    key: "setHeader",
    value: function setHeader(header) {
      this.header = header;
      return this;
    }
  }, {
    key: "setFooterAccessor",
    value: function setFooterAccessor() {
      var footer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
      this.footer = footer;
      return this;
    }
  }, {
    key: "addCellConfig",
    value: function addCellConfig(cellConfig) {
      this.cellConfigs.push(cellConfig);
      return this;
    }
  }, {
    key: "setHeaderClassName",
    value: function setHeaderClassName(headerClassName) {
      this.headerClassName = headerClassName;
      return this;
    }
  }, {
    key: "setFooterClassName",
    value: function setFooterClassName(footerClassName) {
      this.footerClassName = footerClassName;
      return this;
    }
  }, {
    key: "setGetFooterProps",
    value: function setGetFooterProps() {
      var getFooterProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
      this.getFooterProps = getFooterProps;
      return this;
    }
  }, {
    key: "getHeaderProps",
    value: function getHeaderProps() {
      return this.headerProps;
    }
  }, {
    key: "setCellClassName",
    value: function setCellClassName(cellClassName) {
      this.cellClassName = cellClassName;
      return this;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.width = width;
      return this;
    }
  }, {
    key: "setMinWidth",
    value: function setMinWidth(minWidth) {
      this.minWidth = minWidth;
      return this;
    }
  }, {
    key: "setAccessor",
    value: function setAccessor() {
      var accessor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
      this.accessor = accessor;
      return this;
    }
  }, {
    key: "setKey",
    value: function setKey(key) {
      this.key = key;
      return this;
    }
  }, {
    key: "setGetValueFromOnChange",
    value: function setGetValueFromOnChange() {
      var getValueFromOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
      this.getValueFromOnChange = getValueFromOnChange;
      return this;
    }
  }, {
    key: "setMapCellPropsToComponentProps",
    value: function setMapCellPropsToComponentProps() {
      return this;
    }
  }, {
    key: "addChild",
    value: function addChild(child) {
      this.children.push(child);
      return this;
    }
  }, {
    key: "setHeaderRightAlign",
    value: function setHeaderRightAlign() {
      this.isHeaderRightAlign = true;
      return this;
    }
  }, {
    key: "setSearchType",
    value: function setSearchType(type) {
      this.searchType = type;
      return this;
    }
  }, {
    key: "setSearchTermType",
    value: function setSearchTermType(type) {
      this.searchTermType = type;
      return this;
    }
  }, {
    key: "setSortHandler",
    value: function setSortHandler(handler) {
      this.sortHandler = handler;
      return this;
    }
  }, {
    key: "enableSort",
    value: function enableSort() {
      this.sortable = true;
      return this;
    }
  }, {
    key: "enableSearch",
    value: function enableSearch() {
      this.searchable = true;
      return this;
    }
  }, {
    key: "getColumnId",
    value: function getColumnId() {
      return this.id;
    }
  }, {
    key: "getHeader",
    value: function getHeader() {
      return this.header;
    }
  }, {
    key: "getFooterAccessor",
    value: function getFooterAccessor() {
      return this.footer;
    }
  }, {
    key: "getCellConfigs",
    value: function getCellConfigs() {
      return this.cellConfigs;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      return this.children;
    }
  }, {
    key: "getHeaderClassName",
    value: function getHeaderClassName() {
      return this.headerClassName;
    }
  }, {
    key: "getFooterClassName",
    value: function getFooterClassName() {
      return this.footerClassName;
    }
  }, {
    key: "getGetFooterProps",
    value: function getGetFooterProps() {
      return this.getFooterProps;
    }
  }, {
    key: "setGetHeaderProps",
    value: function setGetHeaderProps() {
      var getHeaderProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
      this.getHeaderProps = getHeaderProps;
      return this;
    }
  }, {
    key: "getGetHeaderProps",
    value: function getGetHeaderProps() {
      return this.getHeaderProps;
    }
  }, {
    key: "getCellClassName",
    value: function getCellClassName() {
      return this.cellClassName;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.width;
    }
  }, {
    key: "getMinWidth",
    value: function getMinWidth() {
      return this.minWidth;
    }
  }, {
    key: "getAccessor",
    value: function getAccessor() {
      return this.accessor;
    }
  }, {
    key: "getKey",
    value: function getKey() {
      return this.key;
    }
  }, {
    key: "getGetValueFromOnChange",
    value: function getGetValueFromOnChange() {
      return this.getValueFromOnChange;
    }
  }, {
    key: "resetCellConfigs",
    value: function resetCellConfigs() {
      this.cellConfigs = [];
      return this;
    }
  }, {
    key: "getSortHandler",
    value: function getSortHandler() {
      return this.sortHandler;
    }

    /**
     * value getter function which will return the value to get from the column above on period(.) keypress
     */
  }, {
    key: "setGetValueOnPeriodPress",
    value: function setGetValueOnPeriodPress(getValueOnPeriodPress) {
      this.getValueOnPeriodPress = getValueOnPeriodPress;
      return this;
    }
  }, {
    key: "getGetValueOnPeriodPress",
    value: function getGetValueOnPeriodPress() {
      return this.getValueOnPeriodPress;
    }
  }, {
    key: "setGetValueForKeyboardShortcuts",
    value: function setGetValueForKeyboardShortcuts(getValueForKeyboardShortcuts) {
      this.getValueForKeyboardShortcuts = getValueForKeyboardShortcuts;
      return this;
    }
  }, {
    key: "getGetValueForKeyboardShortcuts",
    value: function getGetValueForKeyboardShortcuts() {
      return this.getValueForKeyboardShortcuts;
    }
  }, {
    key: "getSearchType",
    value: function getSearchType() {
      return this.searchType;
    }
  }, {
    key: "getSearchTermType",
    value: function getSearchTermType() {
      return this.searchTermType;
    }
  }, {
    key: "setSearchAccessor",
    value: function setSearchAccessor(searchAccessor) {
      this.searchAccessor = searchAccessor;
      return this;
    }
  }, {
    key: "setSearchTextNormalizer",
    value: function setSearchTextNormalizer(searchTextNormalizer) {
      this.searchTextNormalizer = searchTextNormalizer;
      return this;
    }
  }]);
  return ColumnConfig;
}();
export default ColumnConfig;